module.exports = __webpack_public_path__ + "static/thumbnail-fibonacci-e43a26e8900a29a0af3b69fcb05cfb61.png";